import React from 'react';
import './Hero.css';
import { motion } from 'framer-motion';

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-title-container">
        <motion.h1 
          className="hero-title"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.2 }}
        >
          <span className="line-1">TRENDY</span>
          <span className="line-2">CLOTHS</span>
          <span className="line-3">FOR MEN</span>
        </motion.h1>
        
        {/* <motion.div 
          className="badge-30"
          animate={{ rotate: 360 }}
          transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
        >
          30% OFF
        </motion.div> */}

        <motion.p 
          className="hero-subtitle"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.8 }}
        >
          2026 SPECIAL EDITION
        </motion.p>
      </div>

      <motion.button 
        className="explore-btn"
        initial={{ opacity: 0, scale: 0.8 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 1 }}
        whileHover={{ scale: 1.05 }}
      >
        EXPLORE NOW 
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="7" y1="17" x2="17" y2="7"></line><polyline points="7 7 17 7 17 17"></polyline></svg>
      </motion.button>

      <div className="hero-images">
        <motion.div 
          className="hero-img-wrapper left"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.4 }}
        >
          <img src="https://blacksalt.ascentbw.com/Images/Home/Hero1.webp" alt="Men Fashion 1" />
        </motion.div>
        <motion.div 
          className="hero-img-wrapper center"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.6 }}
        >
          <img src="https://blacksalt.ascentbw.com/Images/Home/Hero2.webp" alt="Men Fashion 2" />
        </motion.div>
        <motion.div 
          className="hero-img-wrapper right"
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.8 }}
        >
          <img src="https://blacksalt.ascentbw.com/Images/Home/Hero3.webp" alt="Men Fashion 3" />
        </motion.div>
      </div>

      <div className="shop-now-float">
        <div className="shop-now-text">02/08</div>
        <motion.button 
          className="btn-circle"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="7" y1="17" x2="17" y2="7"></line><polyline points="7 7 17 7 17 17"></polyline></svg>
        </motion.button>
        <div className="shop-now-text">SHOP NOW</div>
      </div>
    </section>
  );
};

export default Hero;
